import Assert from "tbAssert";

function NormalizeCalendarParameters(calendarStateParams) {
    Assert.StrictAssert(calendarStateParams != null, "Assertion Failure: Missing UI Router State Parameters Input Dependency");

    let normalizedParams = {
        calendarViewType: calendarStateParams.calendarViewType,
        year: calendarStateParams.year,
        month: calendarStateParams.month,
        day: calendarStateParams.day
    };

    if (calendarStateParams.calendarViewType != null) {
        if (Number.isInteger(parseInt(calendarStateParams.calendarViewType, 10))) {
            normalizedParams.calendarViewType = null;
            normalizedParams.year = calendarStateParams.calendarViewType;
            normalizedParams.month = calendarStateParams.year;
            normalizedParams.day = calendarStateParams.month;
        }
    }

    return normalizedParams;
}

NormalizeCalendarParameters.$inject = [ "$transition$" ];

export default NormalizeCalendarParameters;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/NormalizeCalendarParameters.js
// module id = jPQR
// module chunks = 1